export default __webpack_public_path__ + "static/media/instagram_logo.6db6ef25.png";